import { render, staticRenderFns } from "./topUser.vue?vue&type=template&id=5150f8ca&"
import script from "./topUser.vue?vue&type=script&lang=js&"
export * from "./topUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports